module.exports = __webpack_public_path__ + "static/media/Program5.9940dfb4.jpg";